type TextColumnWidthOptions = {
  characterWidth?: number;
  header?: string;
  maxWidth?: number;
  minWidth?: number;
  paddingWidth?: number;
};

export type TextColumnWidthDefinition<ColumnId extends string> =
  TextColumnWidthOptions & {
    id: ColumnId;
    values: (string | number | null | undefined)[];
  };

const DEFAULT_CHARACTER_WIDTH = 8;
const DEFAULT_MAX_WIDTH = 360;
const DEFAULT_MIN_WIDTH = 120;
const DEFAULT_PADDING_WIDTH = 80;

const getTextValue = (value: string | number | null | undefined) =>
  value === null || value === undefined ? '' : value.toString().trim();

export const getTextColumnWidth = (
  values: (string | number | null | undefined)[],
  {
    characterWidth = DEFAULT_CHARACTER_WIDTH,
    header,
    maxWidth = DEFAULT_MAX_WIDTH,
    minWidth = DEFAULT_MIN_WIDTH,
    paddingWidth = DEFAULT_PADDING_WIDTH,
  }: TextColumnWidthOptions = {},
) => {
  const textValues = [...values.map(getTextValue), getTextValue(header)];
  const widestTextLength = Math.max(
    0,
    ...textValues.map((value) => value.length),
  );
  const calculatedWidth = widestTextLength * characterWidth + paddingWidth;

  return Math.min(maxWidth, Math.max(minWidth, calculatedWidth));
};

export const getTextColumnWidths = <ColumnId extends string>(
  columns: TextColumnWidthDefinition<ColumnId>[],
) =>
  columns.reduce(
    (columnWidths, { id, values, ...options }) => ({
      ...columnWidths,
      [id]: getTextColumnWidth(values, options),
    }),
    {} as Record<ColumnId, number>,
  );
